import { render, staticRenderFns } from "./ReportAppeal.vue?vue&type=template&id=4080bf47&scoped=true"
import script from "./ReportAppeal.vue?vue&type=script&lang=js"
export * from "./ReportAppeal.vue?vue&type=script&lang=js"
import style0 from "./ReportAppeal.vue?vue&type=style&index=0&id=4080bf47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080bf47",
  null
  
)

export default component.exports